module.exports = __webpack_public_path__ + "static/media/job-search-app.9151dd55.png";